export default function TheStudiosSoul() {
  return <section data-section-id="223297" id="profesionalni-servis-romobila" className="bg-background text-foreground py-24 md:py-32 lg:py-48 flex items-center justify-center min-h-screen selection:bg-primary/30 selection:text-primary-foreground">
      <div className="w-full px-6 md:w-3/5 mx-auto flex flex-col items-center text-center space-y-12 md:space-y-16">
        {}
        <span className="text-8xl md:text-9xl text-primary leading-none font-serif block -mb-12 md:-mb-16 select-none opacity-80" aria-hidden="true">
          &ldquo;
        </span>

        {}
        <p className="text-2xl md:text-3xl lg:text-4xl font-serif leading-relaxed md:leading-loose text-foreground/90 tracking-wide">
          Sve počinje s preciznom dijagnostikom – jer vjerujemo da je temeljito
          razumijevanje uzroka ključ dugovječnosti vašeg ljubimca na dva kotača.
          U ChargeZone radionici ne pristajemo na kompromise; koristimo
          isključivo premium dijelove kako bismo osigurali vrhunske performanse.
          Naš cilj je vaša apsolutna sigurnost na cesti, zbog čega na svaki
          obavljeni popravak i ugrađeni dio dajemo jamstvo od 6 mjeseci.
        </p>

        {}
        <div className="pt-8 md:pt-12 flex flex-col items-center gap-4">
          <span className="text-4xl md:text-5xl font-serif italic text-primary block tracking-wider">
            Profesionalni Standardi
          </span>
          <div className="h-px w-12 bg-primary/30 rounded-full" />
          <span className="text-xs md:text-sm text-muted-foreground uppercase tracking-[0.2em] font-default">
            Ovlašteni Servis & Dijagnostika
          </span>
        </div>
      </div>
    </section>;
}